// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=radio]{width:20px;height:20px;vertical-align:top}.radio-label{margin-left:16px}", ""]);
// Exports
module.exports = exports;
